import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'user-picker.input.label',
		defaultMessage: 'select a user',
		description: 'Label for a dropdown menu to choose a user.',
	},
});
